export const StickySettingsActions = {
  ResetStickyState: 'resetStickyState',
  SetStickyStateField: 'setStickyStateField'
};

export const StickySettingsGetters = {
  GetStickyStateField: 'getStickyStateField'
};

export const StickySettingsFields = {
  DocumentTypeId: 'documentTypeId',
  DocumentsLookupState: 'documentsLookupState',
  SelectedDocumentToStoreDocumentType: 'selectedDocumentToStoreDocumentType',
  LastExpandedGroups: 'lastExpandedGroups',
  AppSettings: 'appSettings',
  ShowDeactivated: 'showDeactivated',
  OrganisationId: 'organisationId'
};

export const StickyTableStateFields = {
  CurrentPage: 'tableState.currentPage',
  ItemsPerPage: 'tableState.itemsPerPage',
  SearchQuery: 'tableState.searchQuery',
  SortBy: 'tableState.sortBy',
  SortDesc: 'tableState.sortDesc',
  SelectedPk: 'tableState.selectedPk',
  ShowFilters: 'tableState.showFilters',
  ShowSorting: 'tableState.showSorting'
};

export const StickyStoreNames = {
  AppSettings: 'appSettingsStickyStore',
  UserManagement: 'userManagementStickyStore',
  OrganisationManagement: 'organisationManagementStickyStore',
  DocuSignTemplateManagement: 'docuSignTemplateManagementStickyStore',
  DocuSignSignerRoleManagement: 'docuSignSignerRoleManagementStickyStore',
  DocumentsToStore: 'documentsToStoreStickyStore',
  MStoreGroupedTable: 'mGroupedTableStickyStore',
  ScriveSignerRoleManagement: 'scriveSignerRoleManagementStickyStore',
  ScriveTemplateManagement: 'scriveTemplateManagementStickyStore',
  ListMaintenance: 'listMaintenanceStickyStore',
  BuiltInListItems: 'builtInListItemsStickyStore'
};

export const ListMaintenanceStateFields = {
  ...StickyTableStateFields,
  SortOptions: 'sortOptions',
  FilterOptions: 'filterOptions'
};
